import { Outlet } from "react-router-dom";

const MobileWrapper = () => {
    return <Outlet />;
};

export default MobileWrapper;
